<ng-container *ngIf="coverageId === coverageIdEnum.MotorWA">
    <cyno-tabset customClass="tabset tabset--dark">
        <cyno-tab tabTitle="Wel verzekerd" [active]="true">
            <div class="h3">Wel verzekerd</div>
            <p>Schade die u of een andere bestuurder veroorzaakt aan anderen:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Met uw motor</list-flat-item>
                <list-flat-item>In het verkeer met een aanhangwagen die aan uw motor is gekoppeld</list-flat-item>
                <list-flat-item>Door lading die van uw motor afvalt</list-flat-item>
            </list-flat>
            <p>Ook krijgt u hulp bij ongeval als u niet verder kunt rijden.</p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Niet verzekerd">
            <div class="h3">Niet verzekerd</div>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Schade aan uw eigen motor</list-flat-item>
                <list-flat-item>Schade aan de bestuurder van uw motor</list-flat-item>
                <list-flat-item>Schade aan de lading en bagage die met de motor vervoerd werd</list-flat-item>
            </list-flat>
            <p>En niet verzekerd is:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>
                    Schade door zakelijk gebruik, verhuur of lease van uw motor aan een ander
                </list-flat-item>
                <list-flat-item>
                    Als het kenteken niet op uw naam of naam van uw partner (zelfde adres) staat
                </list-flat-item>
                <list-flat-item>Schade als uw motor wordt gebruikt bij een wedstrijd</list-flat-item>
            </list-flat>
            <p>
                Soms is schade niet verzekerd. Maar verplicht de wet ons dat wij de schade aan een ander wel moeten
                betalen. U moet de schade aan ons terugbetalen. Dit geldt als:
            </p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>U meer alcohol had gedronken dat wettelijk is toegestaan</list-flat-item>
                <list-flat-item>
                    Als u geen geldig rijbewijs had of de schade met opzet heeft veroorzaakt
                </list-flat-item>
                <list-flat-item>Als iemand uw motor gebruikte zonder uw toestemming</list-flat-item>
            </list-flat>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Verzekerde bedragen">
            <div class="h3">Verzekerde bedragen</div>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>€&nbsp;6.500.000 voor schade aan andere personen</list-flat-item>
                <list-flat-item>€&nbsp;2.500.000 voor schade aan spullen van andere personen</list-flat-item>
            </list-flat>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Eigen Risico">
            <div class="h3">Eigen Risico</div>
            <p>€&nbsp;0</p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
    </cyno-tabset>
</ng-container>

<ng-container *ngIf="coverageId === coverageIdEnum.MotorOpStal">
    <cyno-tabset customClass="tabset tabset--dark">
        <cyno-tab tabTitle="Wel verzekerd" [active]="true">
            <div class="h3">Wel verzekerd</div>
            <p>Schade aan uw motor door:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>(Poging tot) diefstal en joyriding</list-flat-item>
                <list-flat-item>Brand en ontploffing</list-flat-item>
                <list-flat-item>Storm, hagel en overstroming</list-flat-item>
                <list-flat-item>Botsing met vogels of loslopende dieren</list-flat-item>
                <list-flat-item>Kortsluiting binnen de motor</list-flat-item>
            </list-flat>
            <p>
                De Beperkt Casco sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA
                verzekering.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Niet verzekerd">
            <div class="h3">Niet verzekerd</div>
            <p>Schade aan uw eigen motor door:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Een aanrijding, parkeren of uw eigen schuld</list-flat-item>
                <list-flat-item>
                    Schade door diefstal als u niet voldoet aan de beveiligingseisen:
                    <list-flat icon="dot" [svg]="true">
                        <list-flat-item>
                            Op het huisadres moet de motor tussen 23.00 uur ’s avonds en 6.00 uur ’s morgens binnen
                            worden gestald
                        </list-flat-item>
                        <list-flat-item>
                            Bij stalling buitenshuis moet de motor (naast normale stuurslot) met een ART categorie 4 of
                            5 kettingslot aan de “vaste“ wereld worden bevestigd
                        </list-flat-item>
                        <list-flat-item>
                            Motor moet voorzien zijn van een alarmsysteem SCM klasse M1 of hoger. Deze moet worden
                            ingeschakeld als u uw motor ergens neer zet)
                        </list-flat-item>
                    </list-flat>
                </list-flat-item>
                <list-flat-item>Schade door slijtage of verkleuringen</list-flat-item>
                <list-flat-item>Materiaal of constructiefouten</list-flat-item>
            </list-flat>
            <p>
                Beperkt Casco sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA
                verzekering.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Verzekerde bedragen">
            <div class="h3">Verzekerde bedragen</div>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Bij schade aan uw motor maximaal de reparatiekosten</list-flat-item>
                <list-flat-item>
                    Bij diefstal of totaal verlies van uw motor maximaal:
                    <list-flat icon="dot" [svg]="true">
                        <list-flat-item>
                            Catalogusprijs als de motor <&nbsp;2&nbsp;jaar is en u de 1e eigenaar bent
                        </list-flat-item>
                        <list-flat-item>
                            Aanschafwaarde als motor <&nbsp;2&nbsp;jaar is en u niet de 1e eigenaar bent
                        </list-flat-item>
                        <list-flat-item>
                            Dagwaarde plus 10% (tot maximaal aanschafwaarde) in alle andere gevallen
                        </list-flat-item>
                    </list-flat>
                </list-flat-item>
                <list-flat-item>Later toegevoegde accessoires tot €&nbsp;500</list-flat-item>
                <list-flat-item>Motorkleding en helm tot €&nbsp;1.000</list-flat-item>
            </list-flat>
            <p>
                De Beperkt Casco sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA
                verzekering.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Eigen Risico">
            <div class="h3">Eigen Risico</div>
            <p>€&nbsp;150</p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
    </cyno-tabset>
</ng-container>

<ng-container *ngIf="coverageId === coverageIdEnum.MotorAllrisk">
    <cyno-tabset customClass="tabset tabset--dark">
        <cyno-tab tabTitle="Wel verzekerd" [active]="true">
            <div class="h3">Wel verzekerd</div>
            <p>Schade aan uw motor door:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>(Poging tot) diefstal en joyriding</list-flat-item>
                <list-flat-item>Brand en ontploffing</list-flat-item>
                <list-flat-item>Storm, hagel en overstroming</list-flat-item>
                <list-flat-item>Botsing met vogels of loslopende dieren</list-flat-item>
                <list-flat-item>Aanrijding, parkeren en eigen schuld (per ongeluk)</list-flat-item>
            </list-flat>
            <p>
                De Allrisk sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA verzekering.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Niet verzekerd">
            <div class="h3">Niet verzekerd</div>
            <p>Schade aan uw eigen motor door:</p>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>
                    Schade door diefstal als u niet voldoet aan de beveiligingseisen:
                    <list-flat icon="dot" [svg]="true">
                        <list-flat-item>
                            Op het huisadres moet de motor tussen 23.00 uur ’s avonds en 6.00 uur ’s morgens binnen
                            worden gestald
                        </list-flat-item>
                        <list-flat-item>
                            Bij stalling buitenshuis moet de motor (naast normale stuurslot) met een ART categorie 4 of
                            5 kettingslot aan de “vaste“ wereld worden bevestigd
                        </list-flat-item>
                        <list-flat-item>
                            Motor moet voorzien zijn van een alarmsysteem SCM klasse M1 of hoger. Deze moet worden
                            ingeschakeld als u uw motor ergens neer zet)
                        </list-flat-item>
                    </list-flat>
                </list-flat-item>
                <list-flat-item>Schade door slijtage of verkleuringen</list-flat-item>
                <list-flat-item>Onderdelen die kapot zijn gegaan (zonder dat sprake is van een ongeval)</list-flat-item>
                <list-flat-item>Schade uitsluitend aan banden</list-flat-item>
                <list-flat-item>Materiaal of constructiefouten</list-flat-item>
            </list-flat>
            <p>
                De Allrisk sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA verzekering.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Verzekerde bedragen">
            <div class="h3">Verzekerde bedragen</div>
            <list-flat icon="dot" [svg]="true">
                <list-flat-item>Bij schade aan uw motor maximaal de reparatiekosten</list-flat-item>
                <list-flat-item>
                    Bij diefstal of totaal verlies van uw motor maximaal:
                    <list-flat icon="dot" [svg]="true">
                        <list-flat-item>
                            Catalogusprijs als de motor <&nbsp;2&nbsp;jaar is en u de 1e eigenaar bent
                        </list-flat-item>
                        <list-flat-item>
                            Aanschafwaarde als motor <&nbsp;2&nbsp;jaar is en u niet de 1e eigenaar bent
                        </list-flat-item>
                        <list-flat-item>
                            Dagwaarde plus 10% bij motoren ouder dan 2 jaar (tot maximaal aanschafwaarde)
                        </list-flat-item>
                    </list-flat>
                </list-flat-item>
                <list-flat-item>Accessoires tot €&nbsp;500</list-flat-item>
                <list-flat-item>Motorkleding €&nbsp;1.000</list-flat-item>
            </list-flat>
            <p>
                De Allrisk sluit u aanvullend op de WA. Voor schade aan anderen gelden de regels van de WA verzekering.
            </p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
        <cyno-tab tabTitle="Eigen Risico">
            <div class="h3">Eigen Risico</div>
            <p>€&nbsp;150</p>
            <ng-container *ngTemplateOutlet="voorwaarden"></ng-container>
        </cyno-tab>
    </cyno-tabset>
</ng-container>

<ng-template #voorwaarden>
    <!-- prettier-ignore -->
    <p>
        Bovenstaande is een samenvatting van onze dekking. Hoe u precies bent verzekerd staat
        <ins-pdf-link [pdfLink]="documentsEnum.ConditionsMotorInsurance" pdfLinkTitle="Voorwaarden Motorverzekering">in
            onze voorwaarden</ins-pdf-link>.
    </p>
</ng-template>
